import { ErrorMessage as FormikErrorMessage } from "formik";

export const ErrorMessage = ({ name }) => (
  <FormikErrorMessage className="text-error-800" name={name} component="div" />
);
